import React from 'react';
import { Card, CardContent, Typography, Avatar, Box, Zoom } from '@mui/material';
import { TrendingUp as TrendingUpIcon } from '@mui/icons-material';

const EstadisticasCard = ({ titulo, valor, icono, color, tendencia }) => (
  <Zoom in timeout={400}>
    <Card sx={{
      background: `linear-gradient(135deg, ${color}12, ${color}06)`,
      border: `1px solid ${color}25`,
      borderRadius: 3,
      minHeight: 100,
      display: 'flex',
      alignItems: 'center',
      transition: 'all 0.2s ease',
      '&:hover': { transform: 'translateY(-3px)', boxShadow: `0 8px 24px ${color}20` }
    }}>
      <CardContent sx={{ display: 'flex', alignItems: 'center', width: '100%', p: 2, '&:last-child': { pb: 2 } }}>
        <Avatar sx={{
          background: `linear-gradient(135deg, ${color}, ${color}CC)`,
          mr: 2, width: 48, height: 48,
          boxShadow: `0 4px 12px ${color}30`
        }}>
          {icono}
        </Avatar>
        <Box sx={{ flex: 1 }}>
          <Typography variant="h4" sx={{ fontWeight: 800, color, lineHeight: 1.1 }}>
            {valor}
          </Typography>
          <Typography variant="body2" color="text.secondary" fontWeight={500}>
            {titulo}
          </Typography>
          {tendencia && (
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.3 }}>
              <TrendingUpIcon sx={{ fontSize: 14, color: '#10B981', mr: 0.3 }} />
              <Typography variant="caption" color="#10B981" fontWeight={700}>{tendencia}</Typography>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  </Zoom>
);

export default EstadisticasCard;
